import { useState, useCallback } from 'react';
import UserApi from 'services/Api/user/UserApi';

interface UseMenuProps {
    logout: () => void;
    isIframe: boolean;
    onClickBack?: () => void;
    openModalLogin: () => void;
    confirmBack?: boolean;
}

export const useMenu = ({
                                          logout,
                                          isIframe,
                                          onClickBack,
                                          openModalLogin,
                                          confirmBack
                                      }: UseMenuProps) => {
    const [openMenu, setOpenMenu] = useState(false);
    const [dialogLogoutOpen, setDialogLogoutOpen] = useState(false);
    const [dialogCloseOpen, setDialogCloseOpen] = useState(false);
    const [dialogDeleteAccountOpen, setDialogDeleteAccountOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const userApi = UserApi();

    const onClickMenu = useCallback(() => {
        setOpenMenu(prev => !prev);
    }, []);

    const onCloseMenu = useCallback(() => {
        setOpenMenu(false);
    }, []);

    const onClickConfirmBack = useCallback(() => {
        if (isIframe) {
            window.parent.postMessage({ command: "CLOSE" }, "*");
        } else {
            onClickBack && onClickBack();
        }
        setDialogCloseOpen(false);
    }, [isIframe, onClickBack]);

    const onClickBackHandle = useCallback(() => {
        if (confirmBack) {
            setDialogCloseOpen(true);
        } else {
            onClickConfirmBack();
        }
    }, [confirmBack, onClickConfirmBack, setDialogCloseOpen]);

    const onClickLogout = useCallback(() => {
        logout();
        setDialogLogoutOpen(false);
    }, [logout]);

    const onClickLogin = useCallback(() => {
        openModalLogin();
    }, [openModalLogin]);

    const onClickDeleteAccount = useCallback(() => {
        setDialogDeleteAccountOpen(true);
        setOpenMenu(false);
    }, []);

    const handleDeleteAccount = useCallback(async () => {
        setIsDeleting(true);
        await userApi.removeAccount();
        logout();
        setDialogDeleteAccountOpen(false);
        setIsDeleting(false);
    }, [logout, userApi]);


    return {
        openMenu,
        dialogLogoutOpen,
        dialogCloseOpen,
        dialogDeleteAccountOpen,
        isDeleting,
        setDialogLogoutOpen,
        setDialogCloseOpen,
        setDialogDeleteAccountOpen,
        onCloseMenu,
        onClickMenu,
        onClickBackHandle,
        onClickLogout,
        onClickLogin,
        onClickDeleteAccount,
        onClickConfirmBack,
        handleDeleteAccount,
    };
};